/** Session flag: aquarium vs legacy sandbox entry (not persisted in domain). */
const ENTRY_KEY = 'specimen-observer:game-entry-mode';

export type GameEntryMode = 'aquarium' | 'legacy';

export function prepareAquariumEntry(): void {
  try {
    sessionStorage.setItem(ENTRY_KEY, 'aquarium');
  } catch {
    // Unwritable storage — GameScreen falls back to legacy when mode is unreadable.
  }
}

export function prepareLegacyEntry(): void {
  try {
    sessionStorage.setItem(ENTRY_KEY, 'legacy');
  } catch {
    // ignore
  }
}

export function getGameEntryMode(): GameEntryMode | null {
  try {
    const v = sessionStorage.getItem(ENTRY_KEY);
    return v === 'aquarium' || v === 'legacy' ? v : null;
  } catch {
    return null;
  }
}

export function clearGameEntryMode(): void {
  try {
    sessionStorage.removeItem(ENTRY_KEY);
  } catch {
    // ignore
  }
}

export function isAquariumEntry(): boolean {
  return getGameEntryMode() === 'aquarium';
}
